import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GridViewStatusChipEvent } from '../types';
import { FontSize } from 'apps/webcomponents/src/ui/gzIconButton/types';

/**
 * @summary This component is a simple status chip for the grid view.
 * It contains a chip with a message and an icon that emits an event when clicked.
 * @tag grid-view-status-chip
 */
@customElement('grid-view-status-chip')
export class GridViewStatusChipWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  text = '';

  @property({ type: String, attribute: true, reflect: true })
  tooltipText = '';

  @property({ type: Boolean, attribute: true, reflect: true })
  readonly = false;

  @property({ type: String, attribute: true, reflect: true })
  icon = 'ds-icon-notification_info';

  @property({ type: String, attribute: true, reflect: true })
  iconSize = FontSize.ICON_SIZE_14;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-tooltip tooltipText="${this.tooltipText}" @click=${this.emitClickEvent}>
        <gz-chip
          text="${this.text}"
          icon="${this.icon}"
          notSelectable
          iconSize="${this.iconSize}"
          ?readonly="${this.readonly}"
        ></gz-chip>
      </gz-tooltip>
    `;
  }

  private emitClickEvent(event: Event): void {
    if (this.readonly) {
      return;
    }
    event.stopPropagation();
    this.dispatchEvent(new CustomEvent(GridViewStatusChipEvent.STATUS_CLICK, { bubbles: true, composed: true }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'grid-view-status-chip': GridViewStatusChipWebComponent;
  }
}
